import { ParticipantsState } from "../Redux/reducers/participantsSlice";
import { decodeNumberFilter } from "../Components/Common/UI/participantFilterFields/customColumnFilterUtils";

/** Keys rendered in the registry filter drawer (API + hardcoded). */
export const REGISTRY_DRAWER_FILTER_KEYS = [
  "gender",
  "occupation",
  "dob",
  "lang",
  "city",
  "state",
  "country",
  "zipcode",
  "status",
  "redactionStatus",
  "participantCode",
  "notesQuery",
  "screenerCompletedFrom",
  "screenerCompletedTo",
  "tagIds",
] as const;

export type StudyDrawerFilterState = Pick<
  ParticipantsState,
  | "siteIds"
  | "status"
  | "isLocked"
  | "screenerCompleted"
  | "screenerReceived"
  | "screenerCompletedFrom"
  | "screenerCompletedTo"
  | "cohortId"
  | "tagIds"
  | "notesQuery"
  | "customHeaderValues"
>;

export function isCustomFilterValueActive(
  value: string | string[] | undefined,
): boolean {
  if (value === undefined || value === null) return false;
  if (Array.isArray(value)) return value.length > 0;
  if (value === "") return false;

  try {
    const parsed = JSON.parse(value);
    if (parsed && typeof parsed === "object" && "op" in parsed) {
      const decoded = decodeNumberFilter(value);
      if (!decoded.op) return false;
      if (decoded.op === "between") {
        return decoded.min !== "" || decoded.max !== "";
      }
      return decoded.val !== "" && decoded.val !== undefined;
    }
  } catch {
    /* plain string / text filter */
  }

  return true;
}

export function hasRegistryDrawerFilters(
  filters: Record<string, string> | undefined,
): boolean {
  if (!filters) return false;
  return REGISTRY_DRAWER_FILTER_KEYS.some((key) => !!filters[key]);
}

export function hasStudyDrawerFilters(state: StudyDrawerFilterState): boolean {
  return (
    state.siteIds.length > 0 ||
    state.status.length > 0 ||
    !!state.isLocked ||
    state.cohortId.length > 0 ||
    state.tagIds.length > 0 ||
    !!state.screenerCompleted ||
    !!state.screenerReceived ||
    !!state.screenerCompletedFrom ||
    !!state.screenerCompletedTo ||
    !!state.notesQuery ||
    state.customHeaderValues.some((v) => isCustomFilterValueActive(v.value))
  );
}

export function buildRegistryDrawerFilterState(
  sliceFilters: Record<string, string> | undefined,
): Record<string, string> {
  const next: Record<string, string> = {};
  REGISTRY_DRAWER_FILTER_KEYS.forEach((key) => {
    next[key] = sliceFilters?.[key] || "";
  });
  return next;
}

export function parseRegistryTagIds(tagIds?: string): string[] {
  if (!tagIds) return [];
  return tagIds.split(",").filter(Boolean);
}

export function formatRegistryTagIds(ids: string[]): string {
  return ids.filter(Boolean).join(",");
}
